module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0652.ca6bb25c.jpg";